export default defineNuxtRouteMiddleware((to) => {
  const params = Object.values(to?.params)
  const slug = params[params.length - 1] as string

  const title = to.meta.title ? to.meta.title : (slug ? decodeURIComponent(parseSlug(slug)) : 'Modus')

  useHead({
    titleTemplate: (title) => {
      if (title === 'Modus') return ''
      return title ? `${title} - Modus` : 'Modus'
    },
    title,
  })
})
